module.exports = __webpack_public_path__ + "img/uo_icon-1.9d378dcf.svg";